import { useTranslate } from "stores/hooks/translation";
import { useEffect, useState } from "react";
import Markdown from "components/markdown";
import { useLocale } from "stores/hooks/locale";
import LoginView from "components/layout/login-view";
import { AccessibilityModel } from "models/accessibility";
import { doGetAccessibility } from "services/public/accessibility";

const PublicAccessibilityView = () => {
  const translate = useTranslate();
  const locale = useLocale();
  const [acc, toggleAcc] = useState<AccessibilityModel | undefined>(undefined);

  useEffect(() => {
    const update = async () => {
      const acc = await doGetAccessibility();
      toggleAcc(acc);
    };
    update();
  }, []);

  if (acc === undefined) {
    return null;
  }

  const title = translate("accessibility");
  const text = acc[locale];
  return (
    <LoginView title={title} transition={false} wide>
      <Markdown>{text}</Markdown>
    </LoginView>
  );
};

export default PublicAccessibilityView;
